import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator, MatSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import { Router } from "@angular/router";
import { ElasticSearchService } from '../../../core/services/elastic-search.service';
import { MatDialog } from '@angular/material';
import { DialogComponent } from './dialog/dialog.component';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.scss'],
    animations: fuseAnimations
})
export class CategoryListComponent implements OnInit, OnDestroy {
    displayedColumns = ['name', 'delete'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    number: any;
    category: Array<any>;
    filteredItems: Array<any>;
    dataSource: MyDataSource;
    private sub: any;
    input: any;
    roles: string;
    constructor(

        private router: Router,
        private dialog: MatDialog,
        private afs: AngularFirestore,
        private elastic: ElasticSearchService) {

        this.sub = afs.collection('categories').valueChanges().subscribe(res => {
            this.number = res.length;
            this.category = res;
            this.dataSource = new MyDataSource(this.category, this.paginator, this.sort);
        })

    }

    ngOnInit() {
        this.roles = localStorage.getItem('currentUserRole');


    }

    deleteCategory(key, product) {
        console.log(product);

        this.dialog.open(DialogComponent, {

            data: {
                key: key
            }
        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
    navigate(uniqueName) {
        this.router.navigate(['/set/categories'], { queryParams: { name: uniqueName } });
    }

    changeTextCategory(string) {
        return string
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '_')
            .replace(/\'/g, '')
            .replace(/\s/g, '_').toLowerCase();
    }

    searchKeyUp(event) {
        const searchInput = this.input.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();
        this.filteredItems = this.category.filter(
            item => {

                return this.changeTextCategory(item.name).indexOf(this.changeTextCategory(this.input)) > -1

            });
        this.dataSource = new MyDataSource(this.filteredItems, this.paginator, this.sort);
    }
}

export class MyDataSource extends DataSource<any> {
    constructor(
        private data: any,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
    }
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.data,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.data.slice();

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    sortData(data): any[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;
                case 'categories':
                    [propertyA, propertyB] = [a.categories[0], b.categories[0]];
                    break;
                case 'price':
                    [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                    break;
                case 'quantity':
                    [propertyA, propertyB] = [a.quantity, b.quantity];
                    break;
                case 'active':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect() { }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/category-list/category-list.component.ts